export enum AnimationPanelViews {
    CANVAS = 'canvas',
    VERSIONS = 'versions',
    COMMENTS = 'comments',
    EXPORT = 'export',
    NONE = 'none',
}
